import React, {useCallback, useEffect, useState} from "react";
import {Page} from "../models/Page";
import {Store, WorkshopData} from "../models/Store";
import {convertWorkshopState2Page} from "../utils/convertWorkshopState2Page";
import {TopPage} from "./pages/TopPage";
import {AreaSelectPage} from "./pages/AreaSelectPage";
import {PrefectureSelectPage} from "./pages/PrefectureSelectPage";
import {DrawingPage} from "./pages/DrawingPage";
import {ConfirmPage} from "./pages/ConfirmPage";
import {EndPage} from "./pages/EndPage";
import {VideoPage} from "./VideoPage";
import {BackgroundMap} from "./BackgroundMap";
import {RandomSmiles} from "./RandomSmiles";
import {WorkshopVideo} from "./WorkshopVideo";
import {ClosedPage} from "./pages/ClosedPage";
import {SmartphoneLandscape} from "./SmartphoneLandscape";

export const VisitorApp = () => {

    // page state

    const [page, setPage] = useState<Page>(Page.Loading);

    // video id state

    const [videoId, setVideoId] = useState('');

    useEffect(() => {

        // グループ指定がない

        if(!Store.groupId){
            setPage(Page.Closed);
            return;
        }

        // get from firebase currently recruiting

        (async () => {

            // 読み込み時のみ対応
            if (page !== Page.Loading) return;

            // 募集中か？取得
            const isRecruiting = await Store.config.isRecruiting();

            // 募集中でなければクローズページを表示
            if(!isRecruiting){
                setPage(Page.Closed);
                return;
            }

            // workshop page listener

            if (Store.isWorkshop) {

                // ワークショップの場合は
                // 設定画面からの操作のリスナーを設定
                Store.firestore_ws_onChange((data: WorkshopData) => {
                    const page = convertWorkshopState2Page(data.scene);
                    setPage(page);
                    const videoId = data.videoId;
                    setVideoId(videoId);
                });
            }else{
                // ワークショップでなければ
                // トップページを表示
                setPage(Page.Top);
            }

        })();
    }, []);

    /*

    event handler

     */

    const onTopDone = useCallback(() => {
        setPage(Page.AreaSelect);
    }, []);

    const onCountrySelectDone = useCallback((arg: string) => {
        if (arg === 'JP') setPage(Page.PrefectureSelect);
        else setPage(Page.Drawing);
    }, []);

    const onPrefectureSelectDone = useCallback((arg: string) => {
        setPage(Page.Drawing);
    }, []);

    const onDrawingDone = useCallback(() => {
        setPage(Page.Confirm);
    }, []);

    const onConfirmDone = useCallback(() => {
        if (Store.isWorkshop) {
            setPage(Page.Video);
            return;
        }
        setPage(Page.End);
    }, []);

    const onEndDone = useCallback(() => {
        setPage(Page.Top);
    }, []);

    const onConfirmBack = useCallback(() => {
        setPage(Page.Drawing);
    }, []);

    /*

    render

    */

    const createPageComponent = (page: Page) => {
        switch (page) {
            case Page.New:
                break;
            case Page.Top:
                return <TopPage onDone={onTopDone}></TopPage>;
            case Page.AreaSelect:
                return <AreaSelectPage onDone={onCountrySelectDone}/>;
            case Page.PrefectureSelect:
                return <PrefectureSelectPage onDone={onPrefectureSelectDone}/>;
            case Page.Drawing:
                return <DrawingPage onDone={onDrawingDone}></DrawingPage>;
            case Page.Confirm:
                return <ConfirmPage onDone={onConfirmDone} onBack={onConfirmBack}/>;
            case Page.End:
                return <EndPage onDone={onEndDone}/>;
            case Page.Video:
                return <VideoPage/>;
            case Page.Closed:
                return <ClosedPage></ClosedPage>;
            case Page.Loading:
                return null;
        }
    };

    return (
        <div>
            <BackgroundMap/>

            <div className="visitor-app">
                <RandomSmiles/>
                {createPageComponent(page)}
                {Store.isWorkshop && <WorkshopVideo page={page} videoId={videoId}/>}
            </div>

            <SmartphoneLandscape/>
        </div>
    );
};